export default {"src":"/_next/static/media/ea.d16444dc.svg","height":27,"width":216};